export const generateShareMessage = (
  type: 'group' | 'event',
  itemName: string
): string => {
  if (type === 'group') {
    return `Ga jij ook alleen naar ${itemName}? Ik zoek soortgenoten! Meld je aan bij Solofix, en laten we een groep vormen!`;
  } else {
    return `Als je alleen gaat naar ${itemName} kun je op Solofix gemakkelijk een groep vinden! Meld je aan bij Solofix, en vind een passende groep!`;
  }
};

export const generateShareUrl = (type: 'group' | 'event', id: string | number): string => {
  const baseUrl = window.location.origin;
  if (type === 'group') {
    return `${baseUrl}/groups/${id}`;
  } else {
    return `${baseUrl}/events/${id}`;
  }
};

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    console.error('Failed to copy to clipboard:', error);
    return false;
  }
};

export const generateHashtags = (type: 'group' | 'event', itemName?: string): string[] => {
  const baseHashtags = ['solofix', 'festivalbuddy', 'groep'];
  
  if (type === 'event' && itemName) {
    // Clean event name for hashtag
    const cleanName = itemName.toLowerCase()
      .replace(/[^\w\s]/gi, '')
      .replace(/\s+/g, '')
      .substring(0, 20);
    if (cleanName) {
      baseHashtags.push(cleanName);
    }
  }
  
  return baseHashtags;
};